const report = {
  title: 'Zgodovina',
  sections: 'Razdelki',
  noReports: 'Še ni izvidov',
  noReportsDescription: 'Ustvarite svoj prvi izvid za začetek.',
  noReportsSearch: 'Ni izvidov za "{{searchQuery}}"',
  noReportsSearchDescription: 'Poskusite z drugo iskalno poizvedbo.',
  createReport: 'Ustvari izvid',
  searchPlaceholder: 'Poišči izvide...',
  section_one: '{{count}} razdelek',
  section_two: '{{count}} razdelka',
  section_few: '{{count}} razdelki',
  section_other: '{{count}} razdelkov',
  loading: 'Nalaganje...',
  deleteConfirm: 'Ali ste prepričani, da želite izbrisati ta izvid?',
  deleteConfirmTitle: 'Izbriši izvid',
  deleteConfirmDescription:
    'Ali ste prepričani, da želite izbrisati "{{name}}"? Tega dejanja ni mogoče razveljaviti.',
  delete: 'Izbriši',
  invalidReportId: 'Neveljaven ID izvida',
  reportNotFound: 'Izvid ni najden',
  patientName: 'Naslov izvida',
  patientNamePlaceholder: 'Ime pacienta (Razlog obiska)',
  addSection: 'Dodaj razdelek',
  noSections: 'Še ni razdelkov. Dodajte prvi razdelek za začetek.',
  sectionTitle: 'Naslov razdelka',
  sectionTitlePlaceholder: 'Glavni simptomi, Anamneza',
  sectionContent: 'Vsebina razdelka',
  sectionContentPlaceholder: 'Vnesite vsebino razdelka...',
  save: 'Shrani',
  cancel: 'Prekliči',
  generateReport: 'Generiraj izvid',
  reportGenerated: 'Izvid uspešno generiran',
  report: 'Izvid',
  downloadPdf: 'Prenesi PDF',
  downloadDocx: 'Prenesi DOCX',
  pdfPreview: 'Predogled PDF',
  previewReport: 'Predogled izvida',
  viewTranscription: 'Pogled transkripcije',
  reportActions: 'Dejanja izvida',
  separator: ' • ',
  reportUpdated: 'Izvid posodobljen',
  deletedSuccessfully: 'Izvid uspešno izbrisan',
  download: 'Prenesi',
  downloading: 'Prenašanje',
  regenerate: 'Ponovno generiraj dokument',
  regenerateDescription: 'Ustvari svež PDF in Word dokument',
  saving: 'Shranjevanje…',
  generatingPreview: 'Posodabljanje predogleda…',
  saved: 'Spremembe shranjene',
  saveChangesFirst: 'Najprej shranite spremembe',
  copyReport: 'Kopiraj izvid',
  copyReportSuccess: 'Kopirano!',
  copyReportError: 'Izvida ni mogoče kopirati',
  status: {
    draft: 'Osnutek',
    recording: 'Snemanje',
    processing: 'Obdelava',
    generating: 'Generiranje',
    completed: 'Zaključeno',
    prepared: 'Pripravljeno',
    transcribing: 'Prepisovanje',
    error: 'Napaka',
  },
  validation: {
    patientNameRequired: 'Naslov izvida je obvezen',
    atLeastOneSectionRequired: 'Vsaj en razdelek je obvezen',
    sectionTitleRequired: 'Naslov razdelka je obvezen',
    sectionContentRequired: 'Vsebina razdelka je obvezna',
  },
  reopenForRecording: 'Snemaj ponovno',
  reopenConfirmTitle: 'Ponovno odpri izvid?',
  reopenConfirmDescription:
    'Izvid bo vrnjen v osnutek. Lahko posnamete dodaten zvok in ponovno generirate dokument.',
  reopenConfirm: 'Ponovno odpri',

  customIntegrations:
    'Za predloge po meri in integracije programske opreme, nam pišite na ',

  errors: {
    notFound: 'Izvid ni najden',
    processingFailed: 'Obdelava ni uspela',
    processingFailedDescription:
      'Pri obdelavi izvida je prišlo do napake. Prosimo, poskusite znova.',
    tryAgainLater: 'Prosimo, počakajte nekaj trenutkov in poskusite znova.',
    retry: 'Poskusi znova',
  },
};

export default report;
